import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import GlobalStyles from "@mui/material/GlobalStyles";

import ErrorFallback from "./components/ErrorFallBack/ErrorFallback";
import { queryClient, persister } from "./store/serverStore";
import { logger } from "./utils/logger";
import getGlobalStyles from "./globalStyles";
import Routes from "./Routes";
import { SnackbarProvider } from "./widgets";

const App = () => {
  const theme = createTheme({
    typography: {
      fontFamily:
        '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
  });

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={logger}>
      <ThemeProvider theme={theme}>
        <GlobalStyles styles={getGlobalStyles()} />
        <SnackbarProvider>
          <PersistQueryClientProvider
            client={queryClient}
            persistOptions={{ persister }}
          >
            <BrowserRouter>
              <Routes />
            </BrowserRouter>
          </PersistQueryClientProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
